import React, {useState} from "react";
import { Form } from "react-bulma-components";
import { Button } from "react-bulma-components";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {getDataFresh} from "../../state/selectors";
import {NotificationManager} from "react-notifications";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import useSafeSave from "../../hooks/useSafeSave";
import FAIcon from "../Icon/FAIcon";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import CreatePartModal from "../PartLookup/CreatePartModal";
import PaymentTypePicker from "../Settings/PaymentTypes/PaymentTypePicker";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import {expenseDueDate, formatDate, readableDate} from "../../utils";
import VatSelector from "../Utils/VatSelector";
import useInlineEditButton from "../../hooks/useInlineEditButton";
import TaxTypePicker from "../Settings/NominalCodes/TaxTypePicker";
import StockConfirmModal from "./StockConfirmModal";

const AsyncTypeahead = asyncContainer(Typeahead);

function PartRow({
                   part,
                   index,
                   onPartUpdate,
                   endpoint,
                   showApprove,
                   onSelectCheck,
                   selected,
                   clearSelected,
                   vehicleTypes,
                   approvedView,
                   makes,
                   models,
                   paymentTypes,
                   nominalCodes,
                   codeObjects,
                   onApprove,
                   trackingOptions,
                   trackingOptionObjects,
                   onNotReadyToInvoice
                 }) {
  const dateFields = ["payment_date", "date_ordered", "invoice_date"];
  const dispatch = useDispatch();
  const [editable, setEditable] = useState(false);
  const [lastEdited, setLastEdited] = useState();
  const [createPartModalOpen, setCreatePartModalOpen] = useState(false);
  const [stockAccrualModalOpen, setStockAccrualModalOpen] = useState(false);
  let dataFresh = useSelector(getDataFresh);

  const paymentTypeObjects =  paymentTypes ? paymentTypes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};

  const onPaymentTypeChange = e => {
    const toUpdate = {
      target: {
        name: e.target.name,
        value: paymentTypeObjects[e.target.value]
      }
    }
    onChange(toUpdate);
  }

  const onTrackingOptionChange = e => {
    const toUpdate = {
      target: {
        name: e.target.name,
        value: trackingOptionObjects[e.target.value]
      }
    }
    onChange(toUpdate);
  }

  const onNominalCodeChange = e => {
    const toUpdate = {
      target: {
        name: e.target.name,
        value: codeObjects[e.target.value]
      }
    };
    onChange(toUpdate);
  }


  const fixEmptyDates = partData => {
    dateFields.forEach(function (date) {
      if (partData[date] === "") {
        partData[date] = null;
      }
    });
    return partData;
  };
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [, setTypeahead] = useState();

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=SP&page_size=40&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handlePartSupplierSelect = supplier => {
    let newPart = {...part, supplier: supplier[0]};
    makeDirty();
    setLastEdited(new Date());
    onPartUpdate(index, newPart);
  };

  const submitUpdate = () => {
    const url = endpoint + "parts/update/" + part.id;
    const data = fixEmptyDates(part);
    const conf = {
      method: "put",
      data,
      url
    };

    return axios(conf).then(() => {
      setEditable(false);
      dispatch(createSetDataFreshAction(dataFresh + 1));
    });
  };

  const onPartApprove = e => {
    e.stopPropagation();
    if (part.part_invoice_number.length > 0) {
      submitUpdate(true);
      clearSelected();
    } else {
      NotificationManager.warning(
        "You must specify an invoice number before approving!",
        "Invoice Number Required",
        10000
      );
    }
  };

  const onSave = e => {
    return submitUpdate();
  };

  const checkUpdated = () => {
    return axios.get(endpoint + "parts/update/" + part.id).then(newPart => {
      return newPart.data.last_saved === part.last_saved;
    });
  };

  const [makeDirty, safeSave] = useSafeSave(
    onSave,
    lastEdited,
    undefined,
    checkUpdated
  );

  const onChange = e => {
    makeDirty();
    setLastEdited(new Date());
    let newPart = {...part};
    newPart[e.target.name] = e.target.value;
    onPartUpdate(index, newPart);
  };

  const onCheck = e => {
    e.stopPropagation();
    onSelectCheck(part);
  };

  const handleCheck = e => {
    const toUpdate = {target: {name: e.target.name, value:e.target.checked}}
    onChange(toUpdate);
  }

  const onCheckboxChange = updatedPart => {
    const url = endpoint + "parts/update/" + part.id;
    const data = fixEmptyDates(updatedPart);
    const conf = {
      method: "put",
      data,
      url
    };

    return axios(conf).then(() => {
      setEditable(false);
      dispatch(createSetDataFreshAction(dataFresh + 1));
    });
  }
  const onStockCheck = e => {
    e.stopPropagation();
    part.from_stock = !part.from_stock;
    return onCheckboxChange(part)
  };

  const handleDueDate = () => {
    let date = expenseDueDate(part, "invoice_date", "supplier");
    if(date){
      return readableDate(formatDate(date));
    }
    else{
      return ""
    }
  }

  const getUrl = () => {
    if(part.part_order){
      return `editpartorder/${part.part_order.id}`
    }
    else if(part.job){
      return `editjob/${part.job.id}`
    }
    else if(part.quote){
      return `editquote/${part.quote.id}`
    }
  }

  const openModal = e => {
    e.stopPropagation();
    setStockAccrualModalOpen(true);
  }

  const vehicle = part.part_order ? {} : part.job ? part.job.vehicle : part.quote.vehicle ;

  return (
      <tr
          className={`clickable small-row-black ${part.returned_from_ready_to_approve ? "table-highlight-red" : ""}`}
          onClick={() =>
              window.open(getUrl(), "_self")
          }
          key={part.id}
      >
        <td>{part.part_order ? `P${part.part_order.id}` : part.job ? `J${part.job.id}` : `Q${part.quote.id}`}</td>
        <td>{vehicle.registration}</td>
        <td>
          {vehicle.make ? vehicle.make.name : ""} {vehicle.model ? vehicle.model.name : ""}
        </td>
        <td
            onClick={e => {
              e.stopPropagation();
            }}
        >
          <Form.Control>
            <Form.Field className="has-addons">
              <AsyncTypeahead
                  useCache={false}
                  id="typeahead"
                  labelKey="display_name"
                  minLength={2}
                  name={"supplier"}
                  onSearch={handleSearch}
                  onChange={handlePartSupplierSelect}
                  placeholder={"Search Supplier"}
                  options={searchData}
                  ref={typeahead => setTypeahead(typeahead)}
                  className="typeahead"
                  isLoading={isLoading}
                  selected={
                    part.supplier && part.supplier.id ? [part.supplier] : []
                  }
                  disabled={!editable}
              />
            </Form.Field>
            <p className="small-row-black has-text-centered">
              {part.supplier && part.supplier.parts_contact_number}
            </p>
          </Form.Control>
        </td>
        {useEditableTableTextCell({
          propName: "name",
          value: part.name,
          onChange,
          onSave: safeSave,
          editable,
          setEditable,
          inlineEdit: false
        })}
        {useEditableTableTextCell({
          propName: "part_number",
          value: part.part_number,
          onChange,
          onSave: safeSave,
          editable,
          setEditable,
          inlineEdit: false
        })}
        {useEditableTableCostCell({
          propName: "cost",
          value: part.cost,
          onChange,
          onSave: safeSave,
          editable,
          setEditable,
          inlineEdit: false
        })}
        <td onClick={e => e.stopPropagation()}>
          <TaxTypePicker
            name={"cost_vat"}
            onChange={onChange}
            disabled={!editable}
            value={part.cost_vat}
            className={"small-column"}
          />
        </td>
        <td onClick={e => e.stopPropagation()}>
          <TrackingOptionsPicker
            name={"supplier_tracking_option"}
            value={part.supplier_tracking_option}
            options={trackingOptions}
            onSave={safeSave}
            onChange={onTrackingOptionChange}
            editable={editable}
            setEditable={setEditable}
            blank={true}
            inlineEdit={false}
            disabled={!editable}
            className={"small-column"}
          />
        </td>
        {useEditableTableDateCell({
          value: part.job ? part.job.workshop_date : "",
        })}
        {useEditableTableDateCell({
          propName: "date_ordered",
          value: part.date_ordered,
          onChange,
          onSave: safeSave,
          editable,
          setEditable,
          inlineEdit: false
        })}
        {<td onClick={(e) => e.stopPropagation()}>
          <PaymentTypePicker
            options={paymentTypes}
            inlineEdit={false}
            blank={true}
            value={part.payment_type}
            editable={editable}
            setEditable={setEditable}
            disabled={!editable}
            onSave={onSave}
            onChange={onPaymentTypeChange}
            className={"small-column"}
          />
          </td>
        }
        <td onClick={(e) => e.stopPropagation()} className={"small-column small-row"}>
          <NominalCodePicker
            options={nominalCodes}
            onSave={onSave}
            onChange={onNominalCodeChange}
            value={part.supplier_nominal_code}
            name={"supplier_nominal_code"}
            inlineEdit={false}
            editable={editable}
            disabled={!editable}
            setEditable={setEditable}
            blank={true}
          />
        </td>
        {useEditableTableTextCell({
          propName: "part_invoice_number",
          value: part.part_invoice_number,
          onChange,
          onSave: safeSave,
          editable,
          setEditable,
          inlineEdit: false
        })}
        {useEditableTableDateCell({
          propName: "invoice_date",
          value: part.invoice_date,
          onSave: safeSave,
          onChange,
          editable,
          setEditable,
          inlineEdit: false
        })}
        {/*useEditableTableDateCell({
          propName: "payment_date",
          value: part.payment_date,
          onChange,
          onSave: safeSave,
          editable,
          setEditable,
          inlineEdit: false
        })*/}
        {useEditableTableTextAreaCell({
          propName: "comments",
          value: part.comments,
          onChange,
          onSave: safeSave,
          editable,
          setEditable,
          inlineEdit: false
        })}
        <td>
          <Form.Field>
            <Form.Control className="table-checkbox">
              <Form.Checkbox
                  checked={part.from_stock}
                  onClick={openModal}
                  type="checkbox"
                  name="from_stock"
                  readOnly
              />
            </Form.Control>
          </Form.Field>
        </td>
        <td>
          {part.created_from_lookup ? part.created_from_lookup.stock_volume : 0}
        </td>
        {useEditableTableDateCell({
          value: part.backorder_expected_date,
          propName: "backorder_expected_date",
          onChange,
          onSave: safeSave,
          editable,
          setEditable,
          inlineEdit: false
        })}
        <td>
          {part.job ? (part.job.workshop.stock_kept_at_supplier ? "YES" : "NO") : ""}
        </td>
        <td onClick={e=>e.stopPropagation()}>
          <Form.Checkbox
            name={"arrived"}
            checked={part.arrived}
            disabled={!editable}
            onChange={handleCheck}
          />
        </td>
        {approvedView &&
            <td>{part.approved && part.approver ? `${part.approver.first_name} ${part.approver.last_name}` : ""}</td>}
        <td onClick={e => e.stopPropagation()}>
          {useInlineEditButton({
            show: true,
            onSave: safeSave,
            editable,
            setEditable,
            disabled: part.approved
          })}
        </td>
        <td onClick={e => e.stopPropagation()}>
          <Form.Field>
            <Form.Control className="table-checkbox">
              <Form.Checkbox
                  checked={selected}
                  type="checkbox"
                  onClick={onCheck}
                  readOnly
              />
            </Form.Control>
          </Form.Field>
        </td>
        {showApprove && (
            <td className="float-right" onClick={(e) => e.stopPropagation()}>
              <Button
                  color={part.ready_to_approve ? "success" : "info"}
                  data-testid={`submit-part-approve${part.id}`}
                  onClick={() => onApprove(part)}
              >
                <FAIcon size="small" icon={["fas", "check"]}/>
              </Button>
            </td>
        )}
        <td onClick={e => {
          e.stopPropagation()
        }}>
          <Button
              disabled={!!part.created_from_lookup}
              color="warning"
              onClick={(e) => {
                setCreatePartModalOpen(true)
              }}
          >
            <b>+</b>
          </Button>
        </td>
        {(part.ready_to_approve && !part.approved) &&
        <td onClick={e => e.stopPropagation()}>
          <Button
            color={"danger"}
            onClick={() => onNotReadyToInvoice(part)}
          >
            UnReady
          </Button>
        </td>
        }
        <div onClick={e => e.stopPropagation()}>
          <CreatePartModal
              open={createPartModalOpen}
              setOpen={setCreatePartModalOpen}
              endpoint={endpoint}
              historicPart={part}
              vehicleTypes={vehicleTypes}
              makes={makes}
              models={models}
          />
        </div>
        <StockConfirmModal
            open={stockAccrualModalOpen}
            setOpen={setStockAccrualModalOpen}
            part={part}
            onConfirm={onStockCheck}
        />
      </tr>
  );
}

export default PartRow;
